import { render, staticRenderFns } from "./UpdateConfiguration.vue?vue&type=template&id=1962ec6a&scoped=true&"
import script from "./UpdateConfiguration.vue?vue&type=script&lang=js&"
export * from "./UpdateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./UpdateConfiguration.vue?vue&type=style&index=0&id=1962ec6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962ec6a",
  null
  
)

export default component.exports